import type { SplitWizardData, SplitWizardState, SplitWizardStep } from './split-wizard-state';


type CommitAction = {
    [K in keyof SplitWizardData]: { type: 'commit'; key: K; value: SplitWizardData[K] }
}[keyof SplitWizardData];


export type SplitWizardAction =
    | CommitAction
    | { type: 'goto'; step: SplitWizardStep }
    | { type: 'next' }
    | { type: 'back' }
    | { type: 'reset'; initialStep: SplitWizardStep };


const shift = (step: SplitWizardStep, delta: 1 | -1, order: SplitWizardStep[]): SplitWizardStep => {
    const index = order.indexOf(step);
    if (index === -1) return step;
    const next = Math.max(0, Math.min(order.length - 1, index + delta));
    return order[next];
};


export const createSplitWizardReducer = (order: SplitWizardStep[]) =>
    (state: SplitWizardState, action: SplitWizardAction): SplitWizardState => {
        if (!action) return state;

        switch (action.type) {
            case 'commit':
                return {
                    ...state,
                    data: { ...state.data, [action.key]: action.value },
                };

            case 'goto':
                return { ...state, step: action.step };

            case 'next':
                return { ...state, step: shift(state.step, 1, order) };

            case 'back':
                return { ...state, step: shift(state.step, -1, order) };

            case 'reset':
                return { step: action.initialStep, data: {} };

            default:
                return state;
        }
    };
